module.exports = __webpack_public_path__ + "static/media/home_parallax.10a82d7d.jpg";